export function apiErrorMessage(data, status) {
  if (data && typeof data.message === 'string' && data.message.trim()) {
    return data.message
  }

  if (data && typeof data.error === 'string' && data.error.trim()) {
    return data.error
  }

  return `HTTP ${status}`
}
